import React, { useEffect, useState } from 'react';
// import { isFirefox, isChrome, isEdge, isSafari } from 'react-device-detect';
import { useDispatch } from 'react-redux';

import { getDateFormat, userId } from '../../_helpers/useful-functions';
// import Spinner from '../../components/ui/spinner';
import { useAppSelector } from '../../store';
import {
    getMomentReportCompanyList,
    getMomentReportMenuList,
    getMomentReportsDashboardFeed,
    setFeedCardData,
} from '../../store/features/moments-reports/momentReportsSlice';
// import NotSupportPage from '../notSupportPage';
import Header from './header';
import ReportsAsideMenu from './reportAsideMenu';
import ReportFeed from './reportFeed';

const MomentReports = (): any => {
    const dispatch = useDispatch();
    const [company, setCompany] = useState([]);
    const [, setWindowSize] = useState({ width: undefined });
    const { reportFilter, companyList, dasboardFeed } = useAppSelector(state => state.momentReports);

    useEffect(() => {
        if (company?.length === 0 && !userId) {
            window.location.href = '/';
        }
    }, []);
    useEffect(() => {
        dispatch(getMomentReportCompanyList());

        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
            });
        }
        setWindowSize({ width: window.innerWidth });

        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        //!in first time add all companyIds...
        const list_ = companyList?.items;
        const companyIds = [];
        if (list_?.length === 0) return;
        if (list_.length > 0) {
            for (let i = 0; i < list_?.length; i++) {
                const companyId = list_[i].id;
                companyIds.push(companyId);
            }
            setCompany(companyIds);
        }
    }, [companyList?.items?.length > 0]);

    useEffect(() => {
        if (company?.length === 0) return;
        if (company?.length > 0) {
            dispatch(
                getMomentReportsDashboardFeed({
                    startDate: getDateFormat({ date_: reportFilter?.startDate }),
                    endDate: getDateFormat({ date_: reportFilter?.endDate }),
                    companyList: company,
                }),
            );
            dispatch(
                getMomentReportMenuList({
                    startDate: getDateFormat({ date_: reportFilter?.startDate }),
                    endDate: getDateFormat({ date_: reportFilter?.endDate }),
                    companyList: company,
                }),
            );
        }
    }, [company?.length > 0]);

    useEffect(() => {
        const boxRowData = [];

        for (let i = 0; i < dasboardFeed?.items?.length; i++) {
            const element = dasboardFeed?.items[i];

            for (let j = 0; j < element?.details?.length; j++) {
                const element2 = element?.details[j];
                boxRowData.push({ name: element2.name, count: element2.count });
            }
        }

        if (boxRowData.length > 0) {
            dispatch(setFeedCardData(boxRowData));
        }
    }, [dasboardFeed?.items]);

    return (
        <>
            {/* {!(isFirefox || isChrome || isEdge || isSafari) ? (
                <>
                    <NotSupportPage />
                </>
            ) : !userId ? (
                <Spinner />
            ) : ( */}
                <>
                    <Header />
                    <>
                        <div className="section-10">
                            <div className="c-wrapper">
                                <ReportsAsideMenu />
                                <ReportFeed />
                            </div>
                        </div>
                    </>
                </>
            {/* )} */}
        </>
    );
};

export default MomentReports;
